<template>
  <div class="documentos-oportunidade">
    <div class="documentos-header">
      <h5 class="m-0">
        Documentos da oportunidade
      </h5>
      <b-btn
        v-if="podeCadastrar"
        class="btn-primary btn-sm"
        @click="abrirModalDocumento"
      >
        <font-awesome-icon :icon="faPlus" />
        Novo documento
      </b-btn>
    </div>

    <div class="table-wrapper">
      <table class="clean-table">
        <thead>
          <tr>
            <th>
              <span class="th-content">
                <font-awesome-icon
                  :icon="faFileAlt"
                  class="th-icon"
                />
                Documento
              </span>
            </th>
            <th>
              <span class="th-content">
                <font-awesome-icon
                  :icon="faFolderOpen"
                  class="th-icon"
                />
                Tipo
              </span>
            </th>
            <th>
              <span class="th-content">
                <font-awesome-icon
                  :icon="faFileAlt"
                  class="th-icon"
                />
                Descrição
              </span>
            </th>
            <th>
              <span class="th-content">
                <font-awesome-icon
                  :icon="faCalendarAlt"
                  class="th-icon"
                />
                Data de Upload
              </span>
            </th>
            <th>
              <span class="th-content">
                <font-awesome-icon
                  :icon="faUser"
                  class="th-icon"
                />
                Usuário
              </span>
            </th>
            <th class="action-col">
              <span class="th-content" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="documento in documentos"
            :key="documento.id"
          >
            <td>
              <strong>{{ documento.nome }}</strong>
            </td>
            <td>
              <span class="documento-type">
                {{ documento.documentTypeLabel || 'Outros' }}
              </span>
            </td>
            <td>
              <span
                v-if="documento.descricao"
                class="descricao-texto"
              >
                {{ documento.descricao }}
              </span>
              <span
                v-else
                class="text-muted"
              >—</span>
            </td>
            <td>{{ documento.dataCadastro || '—' }}</td>
            <td>{{ documento.usuCadastro || '—' }}</td>
            <td>
              <div class="actions">
                <font-awesome-icon
                  :icon="faDownload"
                  class="action"
                  @click="fazerDownload(documento)"
                />
                <font-awesome-icon
                  v-if="podeDeletar && !documento.documentoAssinaturaId"
                  :icon="faTrash"
                  class="action"
                  @click="deletarDocumento(documento)"
                />
              </div>
            </td>
          </tr>
          <tr v-if="!documentos.length">
            <td
              class="text-center"
              colspan="6"
            >
              Nenhum documento cadastrado ainda.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      ref="modalCadastroDocumento"
      title="Cadastrar documento"
      size="md"
      :footer-class="'custom-footer-class'"
      no-close-on-backdrop
    >
      <b-form @submit.prevent="salvarDocumento">
        <b-form-group
          label="Nome do documento"
          label-for="nome"
        >
          <b-form-input
            id="nome"
            v-model="novoDocumento.nome"
            required
          />
        </b-form-group>

        <b-form-group
          label="Tipo de documento"
          label-for="documento-tipo"
        >
          <b-select
            id="documento-tipo"
            v-model="novoDocumento.documentType"
            :options="documentTypeOptions"
            required
          />
        </b-form-group>

        <b-form-group
          label="Descrição"
          label-for="descricao"
        >
          <b-form-textarea
            id="descricao"
            v-model="novoDocumento.descricao"
            rows="2"
            placeholder="Opcional"
          />
        </b-form-group>

        <b-form-group
          label="Arquivo"
          label-for="arquivo"
        >
          <file-upload
            id="arquivo"
            ref="uploadandview"
            v-model="novoDocumento.arquivo"
            class="btn btn-outline-primary btn-sm"
            style="border-radius: 2px;"
            :multiple="false"
          >
            <i class="fas fa-paperclip" />
            Selecionar arquivo
          </file-upload>
          <div
            v-if="novoDocumento.arquivo.length"
            class="arquivo-selecionado"
          >
            <small>Arquivo selecionado: {{ novoDocumento.arquivo[0].name }}</small>
          </div>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button
          variant="outline-secondary"
          @click="$refs.modalCadastroDocumento.hide()"
        >
          Cancelar
        </b-button>
        <b-button
          variant="outline-success"
          :disabled="isSalvandoDocumento"
          @click="salvarDocumento"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.documentos-oportunidade {
  width: 100%;
}

.documentos-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.clean-table {
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
  color: #333;
}

.clean-table thead th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  border-bottom: 1px solid #e2e2e2;
  font-size: 14px;
}

.th-content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.th-icon {
  font-size: 16px;
  color: #777;
}

.clean-table tbody td {
  padding: 12px 8px;
  border-bottom: 1px solid #f1f1f1;
  font-size: 14px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.action {
  cursor: pointer;
  color: #666;
  transition: 0.2s ease;
  font-size: 18px;
}

.action:hover {
  color: #000;
}

.action.delete:hover {
  color: #dc3545;
}

.documento-type {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #495057;
  background-color: #f1f3f5;
  border-radius: 12px;
  padding: 2px 10px;
  font-weight: 500;
}

.descricao-texto {
  font-size: 13px;
  color: #6c757d;
  display: block;
  white-space: normal;
  word-break: break-word;
  max-width: 260px;
}

</style>

<script>

import {
  faCalendarAlt, faDownload, faFileAlt, faFolderOpen, faPlus, faTrash, faUser,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import FileUpload from 'vue-upload-component'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import api from './shared/services/api'

const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg']
const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024
const DOCUMENT_TYPE_OPTIONS = [
  { value: 1, text: 'Contrato' },
  { value: 2, text: 'Relatório' },
  { value: 3, text: 'Fatura' },
  { value: 4, text: 'Proposta' },
]
const DOCUMENT_TYPE_LABELS = {
  1: 'Contrato',
  2: 'Relatório',
  3: 'Fatura',
  4: 'Proposta',
  contract: 'Contrato',
  report: 'Relatório',
  invoice: 'Fatura',
  proposal: 'Proposta',
}

export default {
  name: 'DocumentosOportunidade',
  components: {
    FileUpload,
    FontAwesomeIcon,
  },
  props: {
    dealId: {
      type: [Number, String],
      default: null,
    },
    podeDeletar: {
      type: Boolean,
      default: false,
    },
    podeCadastrar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      faPlus,
      faFolderOpen,
      faCalendarAlt,
      faUser,
      faDownload,
      faTrash,
      faFileAlt,
      documentos: [],
      documentTypeOptions: DOCUMENT_TYPE_OPTIONS,
      novoDocumento: {
        nome: '',
        documentType: null,
        descricao: '',
        arquivo: [],
      },
      isCarregandoDocumentos: false,
      isSalvandoDocumento: false,
    }
  },
  watch: {
    dealId: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.documentos = []
          return
        }
        this.resetForm()
        this.carregarDocumentos()
      },
    },
  },
  methods: {
    abrirModalDocumento() {
      if (!this.podeCadastrar) return
      this.resetForm()
      this.$refs.modalCadastroDocumento.show()
    },
    async carregarDocumentos() {
      if (!this.dealId) {
        this.documentos = []
        return
      }
      this.isCarregandoDocumentos = true
      try {
        const res = await api.getDealDocuments(this.dealId)
        const payload = res && res.data ? res.data : res
        const documentos = Array.isArray(payload) ? payload : []
        this.documentos = documentos.map(doc => this.mapDocument(doc)).filter(Boolean)
      } catch (error) {
        this.documentos = []
        this.toastError('Não foi possível carregar os documentos.', error)
      } finally {
        this.isCarregandoDocumentos = false
      }
    },
    async salvarDocumento() {
      if (!this.dealId || !this.podeCadastrar) return
      const arquivoSelecionado = this.getSelectedFile()
      const nomeValido = this.novoDocumento.nome && this.novoDocumento.nome.trim().length
      const tipoValido = !!this.novoDocumento.documentType
      if (!nomeValido || !tipoValido) {
        this.toastError('Informe o nome e o tipo do documento.')
        return
      }

      if (!arquivoSelecionado) {
        this.toastError('Selecione um arquivo para enviar.')
        return
      }

      const extensao = (arquivoSelecionado.name || '').split('.').pop().toLowerCase()
      const tamanhoValido = arquivoSelecionado.size <= MAX_FILE_SIZE_BYTES
      const extensaoValida = ALLOWED_EXTENSIONS.includes(extensao)

      if (!tamanhoValido) {
        this.toastError('O arquivo deve ter no máximo 10MB.')
        return
      }

      if (!extensaoValida) {
        this.toastError(`Formato não permitido. Use: ${ALLOWED_EXTENSIONS.join(', ')}.`)
        return
      }

      const arquivoParaUpload = this.buildFileToUpload(arquivoSelecionado)
      const formData = new FormData()
      formData.append('file', arquivoParaUpload)
      formData.append('documentType', String(this.novoDocumento.documentType))
      const descricao = this.novoDocumento.descricao && this.novoDocumento.descricao.trim()
      formData.append('description', descricao || this.novoDocumento.nome.trim())

      this.isSalvandoDocumento = true
      try {
        await api.createDealDocument(this.dealId, formData)
        this.toastSuccess('Documento enviado com sucesso.')
        this.resetForm()
        this.$refs.modalCadastroDocumento.hide()
        await this.carregarDocumentos()
      } catch (error) {
        this.toastError('Erro ao enviar o documento.', error)
      } finally {
        this.isSalvandoDocumento = false
      }
    },
    getSelectedFile() {
      const fileEntry = this.novoDocumento.arquivo[0]
      if (!fileEntry) return null
      return fileEntry.file || fileEntry
    },
    buildFileToUpload(file) {
      const desiredName = this.novoDocumento.nome && this.novoDocumento.nome.trim()
      if (!desiredName) return file
      const extension = this.getFileExtension(file.name)
      const baseName = desiredName.replace(/\.[^.]+$/, '') || this.stripExtension(file.name)
      const fileName = extension ? `${baseName}${extension}` : baseName
      try {
        return new File([file], fileName, { type: file.type })
      } catch (error) {
        return file
      }
    },
    getFileExtension(name = '') {
      const pieces = name.split('.')
      return pieces.length > 1 ? `.${pieces.pop()}` : ''
    },
    stripExtension(name = '') {
      return name.replace(/\.[^.]+$/, '')
    },
    normalizeDocumentType(value) {
      if (value == null) return null
      if (typeof value === 'number') return value
      const numeric = Number(value)
      if (!Number.isNaN(numeric)) return numeric
      const normalized = String(value).trim().toLowerCase()
      switch (normalized) {
        case 'contract':
          return 1
        case 'report':
          return 2
        case 'invoice':
          return 3
        case 'proposal':
          return 4
        default:
          return null
      }
    },
    getDocumentTypeLabel(value) {
      if (value == null) return 'Outros'
      const normalized = this.normalizeDocumentType(value) ?? value
      return DOCUMENT_TYPE_LABELS[normalized] || DOCUMENT_TYPE_LABELS[String(value).toLowerCase()] || 'Outros'
    },
    mapDocument(documento = {}) {
      const id = documento.id ?? documento.Id ?? documento.documentId
      const nome = documento.nome || documento.name || documento.fileName || documento.FileName || 'Documento'
      const descricao = documento.descricao || documento.description || ''
      const documentoAssinaturaId = documento.documentoAssinaturaId || null
      const usuCadastro = documento.usuCadastro || ''
      const tipo = this.normalizeDocumentType(documento.documentType ?? documento.documentTypeId ?? documento.tipo)
      const dataCadastro = this.formatarData(documento.createdAt ?? documento.CreatedAt ?? documento.dataCadastro ?? documento.uploadedAt)
      return {
        id,
        nome,
        descricao,
        usuCadastro,
        documentType: tipo,
        documentoAssinaturaId,
        documentTypeLabel: this.getDocumentTypeLabel(tipo ?? documento.documentType),
        dataCadastro,
      }
    },
    formatarData(value) {
      if (!value) return ''
      const data = new Date(value)
      if (!Number.isFinite(data.getTime())) return value
      return data.toLocaleDateString('pt-BR')
    },
    async fazerDownload(documento) {
      try {
        const res = await api.getDocumentDownloadUrl(documento.id)
        const url = res && res.data ? res.data : res
        if (url) {
          window.open(url, '_blank')
        } else {
          this.toastError('URL de download indisponível.')
        }
      } catch (error) {
        this.toastError('Erro ao iniciar o download.', error)
      }
    },
    async deletarDocumento(documento) {
      if (!this.podeDeletar) return
      this.$confirmar(
        'Deseja realmente excluir este documento?',
        'Essa ação não pode ser desfeita.',
        'question', 'danger',
      ).then(async result => {
        if (!result || !result.value) return
        this.$isLoading = true
        await api.deleteDocument(documento.id)
        this.toastSuccess('Documento removido com sucesso.')
        await this.carregarDocumentos()
      }).catch(error => {
        this.toastError('Erro ao deletar o documento.', error)
      }).finally(() => {
        this.$isLoading = false
      })
    },
    resetForm() {
      this.novoDocumento = {
        nome: '',
        documentType: null,
        descricao: '',
        arquivo: [],
      }
      if (this.$refs.uploadandview && this.$refs.uploadandview.clear) {
        this.$refs.uploadandview.clear()
      }
    },
    toastError(message, error) {
      const detalhe = error && (error.response?.data?.title || error.message || error.title || '')
      const title = detalhe ? `${message} (${detalhe})` : message
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    toastSuccess(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: 'CheckCircleIcon',
          variant: 'success',
        },
      })
    },
  },
}
</script>
